export enum AppRoutes {
  COMPONENTS_PAGE = 'contracts',
  VIEW_CONTRACTS = 'view-contracts',
  IMPLEMENTED_CONTRACTS_PAGE = 'implemented-contracts',
  IMPLEMENTED_CUSTOM_TYPES_PAGE = 'implemented-custom-types',
  CONTRACTS_DETAILS_PAGE = 'contract-details',
  FEATURES_DETAILS_PAGE = 'features',
  TYPES_PAGE = 'types',
  TYPE_DETAILS_PAGE = 'type',
  AEM_PAGE = 'exceptions',
  AUTH_PAGE = 'auth',
  VIEW = 'view',
  ENSEMBLE_CONFIG_PAGE = 'ensembles',
  COMPONENT_OWNERSHIP = 'ownerships',
}
